<template>
  <va-create-layout>
    <orders-form :title="title" :item="item" />
  </va-create-layout>
</template>

<script>
export default {
  props: ["title", "item"],
};
</script>
